import { createStyles } from 'antd-style';

export default createStyles(({ css }) => ({
  uploadListWrapper: css`
    display: flex;
    flex-direction: row;
    gap: 16px;
    flex-wrap: wrap;
    align-items: flex-start;
  `,
  uploadFileItem: css`
    position: relative;
    width: 120px;
    min-height: 120px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 12px 8px 8px 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  `,
  uploadFileThumb: css`
    width: 80px;
    height: 60px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    border-radius: 6px;
    overflow: hidden;
  `,
  uploadFileName: css`
    font-size: 13px;
    color: #333;
    text-align: center;
    margin-bottom: 4px;
    word-break: break-all;
    max-width: 100px;
  `,
  uploadFileRemove: css`
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
    background: #fff;
    border: 1px solid #eee;
    color: #ff4d4f;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  `,
  uploadAddButton: css`
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #bbb;
    background: #fafbfc;
    color: #888;
    border-radius: 10px;
    font-size: 16px;
    flex-direction: column;
    cursor: pointer;
    transition: border-color 0.2s;
    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  `,
  // Image preview styles
  imagePreview: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  `,
  // Video preview styles
  videoPreview: css`
    width: 100%;
    height: 100%;
    cursor: pointer;
  `,
  // File type icon styles
  fileTypeIcon: css`
    font-size: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  pptIcon: css`
    color: #1890ff;
  `,
  wordIcon: css`
    color: #722ed1;
  `,
  pdfIcon: css`
    color: #faad14;
  `,
  markdownIcon: css`
    color: #52c41a;
  `,
  genericFileIcon: css`
    font-size: 24px;
    color: #aaa;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  // Upload status styles
  uploadingText: css`
    font-size: 12px;
    color: #aaa;
  `,
  // Modal styles
  modalBodyPdf: css`
    padding: 0;
    height: calc(80vh - 110px);
  `,
  modalBodyMarkdown: css`
    height: 100%;
    overflow: auto;
    padding: 16px;
  `,
  modalBodyDefault: css`
    padding: 24px;
    text-align: center;
  `,
  modalImage: css`
    max-width: 80%;
    max-height: 70vh;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  `,
}));
